import { render, staticRenderFns } from "./StatusKey.vue?vue&type=template&id=537caade&"
import script from "./StatusKey.vue?vue&type=script&lang=js&"
export * from "./StatusKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537caade')) {
      api.createRecord('537caade', component.options)
    } else {
      api.reload('537caade', component.options)
    }
    module.hot.accept("./StatusKey.vue?vue&type=template&id=537caade&", function () {
      api.rerender('537caade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/StatusKey.vue"
export default component.exports